<template>
  <v-data-table
    class="expanded-table expanded-users-table"
    :headers="staticData.headers"
    :items="replacements"
    :items-per-page="-1"
    fixed-header
    hide-default-footer
    no-data-text="Brak aktywnych zastępstw"
  >
    <template #[`item.timespan`]="{item}">
      <div>
        {{ dateRange(item) }}
      </div>
    </template>

    <template #[`item.users`]="{item}">
      <div class="d-flex">
        <AppUser
          v-for="user in item.users"
          :key="'user' + user.id"
          :user="user"
          class="mr-12"
        />
      </div>
    </template>

    <template #[`item.actions`]="{ item }">
      <v-menu
        bottom
        left
        offset-y
      >
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>

        <v-list min-width="160">
          <v-list-item
            dense
            @click="showReplacementModal(item)"
          >
            Edycja
          </v-list-item>

          <v-list-item
            dense
            @click="confirmDeleteReplacement(item)"
          >
            Usuń
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import AppUser from '@/components/UI/AppUser.vue';
import AppAvatarsGroup from '@/components/UI/AppAvatarsGroup.vue';
import headers from '@/helpers/tableHeaders';
import { mapActions } from 'vuex';

export default {
  props: {
    replacements: {
      type: Array,
      default: () => [],
    },
    userId: {
      type: Number,
      required: true,
    },
  },

  components: {
    AppUser,
    AppAvatarsGroup,
  },

  data: () => ({
    staticData: {
      headers: headers.userReplacement,
    },
  }),

  methods: {
    ...mapActions('dialog', [
      'showDialog',
      'clearDialog',
    ]),

    ...mapActions('users', [
      'deleteReplacement',
    ]),

    showReplacementModal(replacement) {
      this.showDialog({
        header: 'Edycja zastępstwa',
        text: 'Wypełnij poniższe dane, aby zmienić zastępstwo.',
        component: 'ReplacementForm',
        props: { replacement },
      });
    },

    confirmDeleteReplacement(replacement) {
      this.showDialog({
        header: 'Usuwanie zastępstwa',
        text: 'Czy na pewno chcesz usunąć zastępstwo',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
      .then(() => {
        this.deleteReplacement(replacement.id)
          .then(() => { this.$emit('delete', this.userId); });
      })
      .catch(() => {
        this.clearDialog();
      });
    },

    replacementUsersCount(replacement) {
      return replacement.users.length;
    },
      dateRange({ from, to }) {
      const { displayDate: format } = this.$root.$options.filters;
      return `${format(from)} - ${format(to)}`;
    },
  },

};
</script>

<style lang="scss" scoped>
.expanded-users-table {
  &::v-deep td, &::v-deep th {
    max-width: unset;
    padding-left: 16px !important;
    border-bottom: 1px solid $secondary !important;
  }
  &::v-deep tr {
    background-color: $bg-light;
  }
}
</style>
